// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u8-0";
export var checkoutRateBadgeLink = "_u8-1";